import React, { useEffect, useState } from "react";
import "../styles/subject-page.css";
import "../styles/mainpage-styles.css";
import "../styles/editorCustomStyles.css"
import { User } from "firebase/auth";
import { getMaterialsWithIds, renameMaterialById, updateMaterialOrder, getAlertsByImpAndLessonandgrade, delMaterial, getTopics, editMaterial } from "../serverlib/db";
import { AuthProvider } from "../contexts/AuthContext";
import AuthPage from "./authpage";
import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { Subject, Alert, Material, Topic, AppUser } from "../serverlib/util-types";
import { getAppUser } from "../serverlib/db";
import Admin from "./admin";
import TextEditor from "./texteditor";
import TopicsPage from "../components/topics";
import MaterialAdd from "../components/materialAdd";
import LanguageSelector from "../components/languageSelector";
//icons
import EditNoteIcon from '@mui/icons-material/EditNote';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

//TRANSLATE PAGE ACCORDING TO THE LANGUAGE OF THE LESSON.
import { useTranslation } from "react-i18next";
import { SearchQueryMaterials } from "../components/SearchQueryMaterials";
import GenericPdfDownloader from "../components/htmlToPdfDownload";
// import { ref } from "firebase/storage";
// import { storage } from "../serverlib/storage";
const CANVAS_WIDTH = 800;

/**
 * Renders the 800px canvas at full size, then scales it down proportionally
 * to fit the available width — identical layout on every device and for PDF.
 */
function CanvasDisplay({ html }: { html: string }) {
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const canvasRef  = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const wrapper = wrapperRef.current;
    const canvas  = canvasRef.current;
    if (!wrapper || !canvas) return;
    let raf = 0;
    const update = () => {
      const available = document.documentElement.clientWidth;
      if (available === 0) return;
      const s = Math.min(1, available / CANVAS_WIDTH);
      // Remove transform to measure true natural height (floats, images all at 800px)
      canvas.style.transform  = 'none';
      canvas.style.marginLeft = '0px';
      const naturalH = canvas.scrollHeight;
      // Apply scale and centering entirely via DOM (no React state) to avoid double-set
      canvas.style.transform  = `scale(${s})`;
      canvas.style.transformOrigin = 'top left';
      canvas.style.marginLeft = `${(available - CANVAS_WIDTH * s) / 2}px`;
      wrapper.style.height    = `${naturalH * s}px`;
    };
    const scheduled = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); };
    update();
    const ro = new ResizeObserver(scheduled);
    ro.observe(wrapper);
    ro.observe(canvas);
    return () => { ro.disconnect(); cancelAnimationFrame(raf); };
  }, [html]);

  return (
    <div ref={wrapperRef} style={{ width: '100%', overflow: 'hidden', marginBottom: '18vh' }}>
      <div
        ref={canvasRef}
        id="download-as-pdf"
        className="subject-textfield subject-textmat"
        style={{ width: CANVAS_WIDTH, backgroundColor: 'white', color: 'black' }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}

interface SubjectPageProps {
  user: User | null;
  appUser: AppUser | null;
}
function SubjectPage(props: SubjectPageProps) {
  const { t } = useTranslation('common');
  const user = props.user;
  var [appUser, setAppUser] = useState<AppUser | null>(null);
  const navigate = useNavigate();

  const currentPath = useLocation().pathname;
  const [searchParams, setSearchParams] = useSearchParams();
  type MaterialWithId = Material & { _id: string };
  const [materials, setMaterials] = useState<MaterialWithId[]>([]);
  const [renamingId, setRenamingId] = useState<string | null>(null);
  const [renameValue, setRenameValue] = useState('');
  const [alertList3, setAlertList3] = useState<Alert[]>([]);
  const [alertList4, setAlertList4] = useState<Alert[]>([]);

  // Topic state is derived from the URL ?topic=Unit/Subtopic
  // This makes browser back/forward work correctly
  const topicParam = searchParams.get('topic') || '';
  const topicParts = topicParam.split('/');
  const textMatTopicUnit     = topicParts[0] || '';
  const textMatTopicSubtopic1 = topicParts[1] || '';

  const setTextMatTopicUnit = (unit: string) => {
    if (unit === '') {
      setSearchParams({}, { replace: true });
    } else {
      setSearchParams({ topic: unit + '/' }, { replace: true });
    }
  };
  const setTextMatTopicSubtopic1 = (sub: string) => {
    setSearchParams({ topic: textMatTopicUnit + '/' + sub }, { replace: true });
  };
  const [topicList, setTopicList] = useState<Topic[]>([]);
  // Split the path using '/'
  const pathParts = currentPath.split('/');
  const grade = pathParts[2];
  const subjectfromurl = pathParts[3];
  const subject = decodeURIComponent(subjectfromurl) as Subject;
  const subjectbasicform = decodeURIComponent(subjectfromurl);
  // change the subject name derived from the url to the one that will be displayed
  var subjectToDisplay = subjectbasicform;

  //#region subjectToDisplay
  if (subjectbasicform === "türkdiliveedebiyatı") {
    subjectToDisplay = "Türk Dili ve Edebiyatı";
  } else if (subjectbasicform === "mathématiques") {
    subjectToDisplay = "Mathématiques";
  } else if (subjectbasicform === "physique") {
    subjectToDisplay = "Physique";
  } else if (subjectbasicform === "chimie") {
    subjectToDisplay = "Chimie";
  } else if (subjectbasicform === "biologie") {
    subjectToDisplay = "Biologie";
  } else if (subjectbasicform === "bilgisayarbilimi") {
    subjectToDisplay = "Bilgisayar Bilimi";
  } else if (subjectbasicform === "felsefe") {
    subjectToDisplay = "Felsefe";
  } else if (subjectbasicform === "psikoloji") {
    subjectToDisplay = "Psikoloji";
  } else if (subjectbasicform === "sosyoloji") {
    subjectToDisplay = "Sosyoloji";
  } else if (subjectbasicform === "tarih") {
    subjectToDisplay = "Tarih";
  } else if (subjectbasicform === "coğrafya") {
    subjectToDisplay = "Coğrafya";
  } else if (subjectbasicform === "müzik") {
    subjectToDisplay = "Müzik";
  } else if (subjectbasicform === "görselsanatlar") {
    subjectToDisplay = "Görsel Sanatlar";
  } else if (subjectbasicform === "bedeneğitimi") {
    subjectToDisplay = "Beden Eğitimi";
  } else if (subjectbasicform === "français") {
    subjectToDisplay = "Français";
  } else if (subjectbasicform === "english") {
    subjectToDisplay = "English";
  } else if (subjectbasicform === "sağlıkbilgisivetrafikkültürü") {
    subjectToDisplay = "Sağlık Bilgisi ve Trafik Kültürü";
  } else if (subjectbasicform === "dinkültürüveahlakbilgisi") {
    subjectToDisplay = "Din Kültürü ve Ahlak Bilgisi";
  } else if (subjectbasicform === "sciences") {
    subjectToDisplay = "Sciences";
  } else if (subjectbasicform === "seçmelitürkdiliveedebiyatı") {
    subjectToDisplay = "Seçmeli Türk Dili ve Edebiyatı";
  } else if (subjectbasicform === "tci̇nkılaptarihiveatatürkçülük") {
    subjectToDisplay = "T.C. İnkılap Tarihi ve Atatürkçülük";
  } else if (subjectbasicform === "psikoloji") {
    subjectToDisplay = "Psikoloji";
  } else if (subjectbasicform === "mantık") {
    subjectToDisplay = "Mantık";
  } else if (subjectbasicform === "çağdaştürkvedünyatarihi") {
    subjectToDisplay = "Çağdaş Türk ve Dünya Tarihi";
  } else if (subjectbasicform === "türkkültürvemedeniyettarihi") {
    subjectToDisplay = "Türk Kültür ve Medeniyet Tarihi";
  } else if (subjectbasicform === "emi") {
    subjectToDisplay = "EMI";
  }

  const subjectImage = require(`../img/${subjectbasicform}.jpg`);

  //#endregion subjectToDisplay
  // Get the grade from the path
  var gradeint = String(grade.match(/\d+/g));
  if (gradeint === "null") {
    gradeint = "Prep";
  }
  const numericGrade = gradeint ? parseInt(gradeint[0]) : undefined;

  var gradetoshow;
  function getGrade() {
    if (numericGrade !== null && numericGrade !== undefined && gradeint !== undefined && gradeint !== null) {
      gradetoshow = gradeint + t("subjectpage.thgrader");
      if (gradeint === "Prep") {
        gradetoshow = t("subjectpage.prep");
      }
    } else {
      gradetoshow = t("subjectpage.prep") as string;
    }
  }
  getGrade();
  const handleGetTopics = async () => {
    try {
      getTopics(subject, "subjects" + gradeint).then((topics: Topic[]) => {
        setTopicList(topics);
        return topics as Topic[];
      });
    } catch (error) {
      console.error('Error fetching topics:', error);
    }
  }

  useEffect(() => {
    handleGetTopics();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!user?.uid) return;
    getAppUser(user.uid).then(au => {
      if (au) setAppUser(au as AppUser);
    }).catch(err => console.error("getAppUser error:", err));
  }, [user]);

  //fetch text materials to later map them by topic and grade and subject
  useEffect(() => {
    getMaterialsWithIds(subject, gradeint).then(rows => {
      // Sort by `order` field if present, otherwise preserve fetch order
      const sorted = [...rows].sort((a, b) => {
        const ao = (a as any).order ?? Infinity;
        const bo = (b as any).order ?? Infinity;
        return ao - bo;
      });
      setMaterials(sorted);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradeint, subject]);

  const handleRenameMaterial = async (mat: MaterialWithId, newName: string) => {
    const trimmed = newName.trim();
    if (!trimmed || trimmed === mat.name) { setRenamingId(null); return; }
    const ok = await renameMaterialById(subject, gradeint, mat._id, trimmed);
    if (ok) setMaterials(prev => prev.map(m => m._id === mat._id ? { ...m, name: trimmed } : m));
    setRenamingId(null);
  };

  // Drag-and-drop state
  const [dragId, setDragId] = useState<string | null>(null);
  const [dropIndex, setDropIndex] = useState<number | null>(null);
  const matContainerRef = React.useRef<HTMLDivElement | null>(null);

  const isPrivileged = !!(appUser?.isAdmin || appUser?.accesslevel === "teacher");

  // Compute insertion index from pointer position relative to visible cards in the container.
  // Cards are laid out in a wrapping flex row; we find the closest gap.
  const computeDropIndex = (clientX: number, clientY: number, visibleIds: string[]): number => {
    const container = matContainerRef.current;
    if (!container) return visibleIds.length;
    const cards = visibleIds.map(id =>
      container.querySelector(`[data-mat-id="${id}"]`) as HTMLElement | null
    ).filter(Boolean) as HTMLElement[];

    if (cards.length === 0) return 0;

    let best = cards.length; // default: after last
    let bestDist = Infinity;

    cards.forEach((card, i) => {
      const rect = card.getBoundingClientRect();
      // Distance from pointer to left edge of this card
      const distLeft  = Math.hypot(rect.left  - clientX, rect.top + rect.height / 2 - clientY);
      // Distance from pointer to right edge of this card
      const distRight = Math.hypot(rect.right - clientX, rect.top + rect.height / 2 - clientY);

      if (distLeft < bestDist) { bestDist = distLeft; best = i; }
      if (distRight < bestDist) { bestDist = distRight; best = i + 1; }
    });

    return best;
  };

  const handleDragStart = (id: string) => { setDragId(id); };

  const handleContainerDragOver = (e: React.DragEvent, visibleIds: string[]) => {
    e.preventDefault();
    setDropIndex(computeDropIndex(e.clientX, e.clientY, visibleIds));
  };

  const handleContainerDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    // Only clear if leaving the container entirely (not entering a child)
    if (!matContainerRef.current?.contains(e.relatedTarget as Node)) {
      setDropIndex(null);
    }
  };

  const commitDrop = (visibleIds: string[]) => {
    if (dragId !== null && dropIndex !== null) {
      setMaterials(prev => {
        // Work only on the visible slice; hidden (text) materials stay in place
        const visibleMats = prev.filter(m => visibleIds.includes(m._id));
        const hiddenMats  = prev.filter(m => !visibleIds.includes(m._id));
        const fromIdx = visibleMats.findIndex(m => m._id === dragId);
        if (fromIdx < 0) return prev;
        const next = [...visibleMats];
        const [moved] = next.splice(fromIdx, 1);
        // Adjust target index: if dragging from before the drop point, index shifts by 1
        const adjustedIdx = dropIndex > fromIdx ? dropIndex - 1 : dropIndex;
        next.splice(adjustedIdx, 0, moved);
        const combined = [...next, ...hiddenMats];
        updateMaterialOrder(subject, gradeint, combined.map(m => m._id));
        return combined;
      });
    }
    setDragId(null);
    setDropIndex(null);
  };

  // Touch drag — long-press to initiate, then free drag with scroll locked
  const longPressTimer   = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const touchDragActive  = React.useRef(false);
  const touchDragId      = React.useRef<string | null>(null);
  const touchVisibleIds  = React.useRef<string[]>([]);

  // Called from JSX onTouchStart on each card (passive, just registers the long-press)
  const handleTouchStart = (e: React.TouchEvent, id: string, visIds: string[]) => {
    if (!isPrivileged) return;
    const touch = e.touches[0];
    const startX = touch.clientX;
    const startY = touch.clientY;

    longPressTimer.current = setTimeout(() => {
      // Confirm finger hasn't moved much (not a scroll gesture)
      touchDragActive.current = true;
      touchDragId.current = id;
      touchVisibleIds.current = visIds;
      setDragId(id);

      // Lock document scroll for the duration of this drag
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      // Register non-passive move/end listeners directly so we can preventDefault
      const onMove = (ev: TouchEvent) => {
        if (!touchDragActive.current) return;
        ev.preventDefault();
        const t = ev.touches[0];
        setDropIndex(computeDropIndex(t.clientX, t.clientY, touchVisibleIds.current));
      };
      const onEnd = () => {
        touchDragActive.current = false;
        touchDragId.current = null;
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
        document.removeEventListener('touchcancel', onEnd);
        // Use functional update so we always read latest state
        setDragId(prev => { void prev; return null; });
        setDropIndex(prev => {
          if (prev !== null) {
            // commitDrop equivalent using refs — can't call commitDrop (stale closure)
            setMaterials(mats => {
              const vIds = touchVisibleIds.current;
              const visibleMats = mats.filter(m => vIds.includes(m._id));
              const hiddenMats  = mats.filter(m => !vIds.includes(m._id));
              const fromIdx = visibleMats.findIndex(m => m._id === id);
              if (fromIdx < 0) return mats;
              const next = [...visibleMats];
              const [moved] = next.splice(fromIdx, 1);
              const adjustedIdx = prev > fromIdx ? prev - 1 : prev;
              next.splice(adjustedIdx, 0, moved);
              const combined = [...next, ...hiddenMats];
              updateMaterialOrder(subject, gradeint, combined.map(m => m._id));
              return combined;
            });
          }
          return null;
        });
      };

      document.addEventListener('touchmove',   onMove,  { passive: false });
      document.addEventListener('touchend',    onEnd);
      document.addEventListener('touchcancel', onEnd);
    }, 400); // 400ms long-press threshold

    // If finger moves before long-press fires, cancel it
    const cancelLongPress = (ev: TouchEvent) => {
      const dx = ev.touches[0].clientX - startX;
      const dy = ev.touches[0].clientY - startY;
      if (Math.hypot(dx, dy) > 8) {
        if (longPressTimer.current) clearTimeout(longPressTimer.current);
      }
    };
    // One-shot: removed after touchend/cancel
    const cleanup = () => {
      if (longPressTimer.current) clearTimeout(longPressTimer.current);
      e.target!.removeEventListener('touchmove',   cancelLongPress as EventListener);
      e.target!.removeEventListener('touchend',    cleanup as EventListener);
      e.target!.removeEventListener('touchcancel', cleanup as EventListener);
    };
    (e.target as HTMLElement).addEventListener('touchmove',   cancelLongPress as EventListener, { passive: true });
    (e.target as HTMLElement).addEventListener('touchend',    cleanup as EventListener);
    (e.target as HTMLElement).addEventListener('touchcancel', cleanup as EventListener);
  };

  //handle remove material
  const handleRemoveMaterial = async (material: Material) => {
    try {
      await delMaterial(material, gradeint, subject, textMatTopic).then(() => {
        console.log('Material successfully deleted: ', material.name, "\n", "Grade: ", gradeint, "\n", "Subject: ", subject);
        // Remove the deleted material from the materials array, dont remove if the deleted material's creation time is not the same as another material's. sometimes an additional material is accidentally added with the same content but at a random time. only remove one of the materials.
        const newMaterials = materials.filter((mat) => mat.content !== material.content || mat.time !== material.time);
        setMaterials(newMaterials);
      });
    } catch (error) {
      console.error('Error removing material:', error);
      console.error('Material:', material);
      console.error('Grade:', grade);
      console.error('Subject:', subject);
    }
  }
  //get alerts to map them
  useEffect(() => {
    const fetchAlerts = async () => {
      const importance3Alerts = await getAlertsByImpAndLessonandgrade(3);
      console.log("importance3Alerts: ", importance3Alerts);
      const filteredAlerts3 = importance3Alerts?.filter((alert3) =>
        alert3.lessonandgrade && alert3.lessonandgrade.includes(gradeint) && alert3.lessonandgrade.includes(subjectbasicform)
      );
      setAlertList3(filteredAlerts3 as Alert[]);

      const importance4Alerts = await getAlertsByImpAndLessonandgrade(4);
      const filteredAlerts4 = importance4Alerts?.filter((alert4) =>
        alert4.lessonandgrade && alert4.lessonandgrade.includes(gradeint) && alert4.lessonandgrade.includes(subjectbasicform)
      );
      setAlertList4(filteredAlerts4 as Alert[]);
    };

    fetchAlerts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //handle admin popup (add material- add alert) 
  const lockScroll   = () => { const pw = document.querySelector('.page-wrapper') as HTMLElement; if (pw) pw.style.overflowY = 'hidden'; };
  const unlockScroll = () => { const pw = document.querySelector('.page-wrapper') as HTMLElement; if (pw) pw.style.overflowY = ''; };

  // Ensure scroll is restored if this component unmounts while a popup is open
  useEffect(() => {
    return () => {
      const pw = document.querySelector('.page-wrapper') as HTMLElement;
      if (pw) pw.style.overflowY = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  const subjectpageadmin = () => {
    const adminPopupElement = document.querySelector('.admin-popup') as HTMLElement;
    adminPopupElement.style.display = 'block';
    lockScroll();
  };
  const closesubjectpageadmin = () => {
    const adminPopupElement = document.querySelector('.admin-popup') as HTMLElement;
    adminPopupElement.style.display = 'none';
    unlockScroll();
  };

  const subjectpageaddmaterial = () => {
    const adminPopupElement = document.querySelector('.add-material-popup') as HTMLElement;
    adminPopupElement.style.display = 'block';
    lockScroll();
  }
  const closesubjectpageaddmaterial = () => {
    const adminPopupElement = document.querySelector('.add-material-popup') as HTMLElement;
    adminPopupElement.style.display = 'none';
    unlockScroll();
  }

  const closesubjectpagetopics = () => {
    const adminPopupElement = document.querySelector('.topics-popup') as HTMLElement;
    adminPopupElement.style.display = 'none';
    unlockScroll();
  };

  const subjectpagetexteditor = () => {
    const adminPopupElement = document.querySelector('.texteditor-popup') as HTMLElement;
    adminPopupElement.style.display = 'block';
    lockScroll();
  };
  const closesubjectpagetexteditor = () => {
    const adminPopupElement = document.querySelector('.texteditor-popup') as HTMLElement;
    adminPopupElement.style.display = 'none';
    unlockScroll();
  };

  //update material visibility
  const updateMaterialVisibility = (material: Material, newVisibility: boolean) => {
    const newMaterials = materials.map((mat) => {
      if (mat.content === material.content) {
        mat.visible = newVisibility;
      }
      return mat;
    });
    setMaterials(newMaterials);
  }

  // textMatTopic is derived directly from the URL — no separate state needed
  const textMatTopic = topicParam !== '' ? topicParam : '/';

  // Save session so main.tsx can restore it on fresh app load (40-min expiry).
  useEffect(() => {
    if (topicParam !== '') {
      localStorage.setItem("subjectpageSession", JSON.stringify({
        subject: subjectbasicform,
        grade: grade,
        topic: topicParam,
        resetByTime: new Date().getTime() + 4800000 // 80 minutes. 2400000 is 40 minutes. in ms.
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicParam, subjectbasicform, grade]);
  if (user) {
    return (
      <div className="page-wrapper">
        <div className="header-frost"></div>
        <div className="subject-header" style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.5)), url(${subjectImage})`
        }}>
          <div className="header-left">
            <button className="icon-button" style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'contents', color: 'inherit' }} onClick={() => { localStorage.setItem("subjectpageSession", ''); navigate('/', { replace: true }); }}><KeyboardBackspaceOutlinedIcon /></button>
            <div className="vertical-line"></div>
            <span className="greeting">
              <span className="greeting-sentence">{gradetoshow}</span>
              <span>{subjectToDisplay}</span>
            </span>
          </div>
          {/* EDIT PAGE BUTTON */}
          {(appUser?.isAdmin || appUser?.accesslevel === "teacher") && (
            <button className="icon-button hover-up" onClick={subjectpageadmin}><EditIcon /></button>
          )}
        </div>
        <div className="announcements-wrapper">
          <div className="section-title"><span>📢 <b>{t('subjectpage.announcements')}</b></span></div>
          {/* {t('subjectpage.announcements-title')} */}
          {alertList3.length > 0 && (
            <div id="alert-wrapper">
              {alertList3 && alertList3.map((alert, index) => (
                <div key={index}>
                  <div className="alert-item" key={alert.title}>
                    <h2>{alert.title}
                      <span>• {alert.author}</span>
                    </h2>
                    <p>{alert.message}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
          {alertList4.length > 0 && (
            <div id="announcement-wrapper">
              {alertList4 && alertList4.map((alert, index) => (
                <div key={index}>
                  <hr />
                  <div className="announcement-item" key={alert.title}>
                    <h2>{alert.title}
                      <span>• {alert.author}</span>
                    </h2>
                    <p>{alert.message}</p>
                  </div>
                </div>
              ))}
            </div>

          )}
          {alertList3.length === 0 && alertList4.length === 0 && (
            <div className="no-alerts-text"><b>{t('subjectpage.no-announcements-header')}</b>
              <br /> {t('subjectpage.no-announcements-text')}</div>
          )}
          <div style={{ height: "12px" }}></div>
        </div>

        <div className="materials-wrapper">
          <div className="section-title">📚 <b>{t('subjectpage.materials')}</b>
          </div>

          <div className="unit-radio-wrapper">
            <p style={{ marginBottom: "0", marginTop: "8px" }}>📖 <b>{t('subjectpage.filter-materials')}</b></p>

            <SearchQueryMaterials materials={materials} />

            <div className="unit-radio" role="group" aria-label={t('subjectpage.topic-unit')}>
              <span><b>{t('subjectpage.topic-unit')}</b></span>
              <button
                className={`chip-btn${textMatTopicUnit === "" ? " chip-btn-active" : ""}`}
                onClick={() => setTextMatTopicUnit("")}
                type="button"
              ><HomeIcon /></button>
              {topicList.length > 0 && topicList.map((topic, index) => (
                <button
                  key={index}
                  className={`chip-btn${textMatTopicUnit === topic.tname ? " chip-btn-active" : ""}`}
                  onClick={() => setTextMatTopicUnit(topic.tname)}
                  type="button"
                >{topic.tname}</button>
              ))}
            </div>
            {textMatTopicUnit !== "" && (
              <div className="topic-radio" role="group" aria-label={t('subjectpage.topic-chapter')}>
                <span><b>{t('subjectpage.topic-chapter')}</b></span>
                <button
                  className={`chip-btn${textMatTopicSubtopic1 === "" ? " chip-btn-active" : ""}`}
                  onClick={() => setTextMatTopicSubtopic1("")}
                  type="button"
                ><HomeIcon /></button>
                {(topicList.length > 0 && textMatTopicUnit !== "") &&
                  topicList.map((topic) => (
                    topic.tname === textMatTopicUnit && topic.subtopics.length > 0 &&
                    topic.subtopics.map((subtopic, index) => (
                      <button
                        key={index}
                        className={`chip-btn${textMatTopicSubtopic1 === subtopic ? " chip-btn-active" : ""}`}
                        onClick={() => setTextMatTopicSubtopic1(subtopic)}
                        type="button"
                      >{subtopic}</button>
                    ))
                  ))
                }
              </div>
            )}
          </div>
          {/* <div style={{ alignSelf: "center", textAlign: "center", width: "100%", fontSize: "18px", fontWeight: "bold", marginTop: "12px" }}
            className="subject-textfield-topic-title">
            {t("subjectpage.topic-topic")} : {textMatTopic === "/" ? <>{t('subjectpage.mainpage')}</> : <>{textMatTopicUnit} / {textMatTopicSubtopic1.length !== 0 ? <>{textMatTopicSubtopic1}</> : <>{t('subjectpage.sub-general')}</>} </>}
          </div> */}
          {(() => {
            // Collect visible (non-text) material IDs for this topic — used by drag logic
            const visibleMats = materials
              ? materials.filter(m => m.materialtype !== "text" && (m.visible || isPrivileged) && m.topic === textMatTopic)
              : [];
            const visibleIds = visibleMats.map(m => m._id);

            return (
              <div
                className="materials-content"
                ref={matContainerRef}
                onDragOver={isPrivileged && dragId ? e => handleContainerDragOver(e, visibleIds) : undefined}
                onDragLeave={isPrivileged && dragId ? handleContainerDragLeave : undefined}
                onDrop={isPrivileged ? e => { e.preventDefault(); commitDrop(visibleIds); } : undefined}
              >
                {/* add material card */}
                {user && isPrivileged && (
                  <div className="material-item hover-up add-material-item" onClick={subjectpageaddmaterial}>
                    <NoteAddIcon />
                    <p> {textMatTopic === "/" ? <>{t('subjectpage.mainpage')}</> : <>{textMatTopicUnit} / {textMatTopicSubtopic1.length !== 0 ? <>{textMatTopicSubtopic1}</> : <>{t('subjectpage.sub-general')}</>} </>} </p>
                    <span style={{ textAlign: "center" }}><b>{t('subjectpage.add-material')}</b></span>
                  </div>
                )}

                {visibleMats.map((material, visIdx) => {
                  const isDragging = dragId === material._id;
                  const showIndicatorBefore = isPrivileged && dragId && dropIndex === visIdx && dragId !== material._id;
                  const showIndicatorAfter  = isPrivileged && dragId && dropIndex === visIdx + 1 && visIdx === visibleMats.length - 1;
                  return (
                    <React.Fragment key={material._id}>
                      {showIndicatorBefore && <div className="mat-drop-indicator" />}
                      <div
                        className={`material-item hover-up${isDragging ? ' mat-dragging' : ''}`}
                        data-mat-id={material._id}
                        draggable={isPrivileged}
                        onDragStart={isPrivileged ? () => handleDragStart(material._id) : undefined}
                        onDragEnd={isPrivileged ? () => commitDrop(visibleIds) : undefined}
                        onTouchStart={isPrivileged ? e => handleTouchStart(e, material._id, visibleIds) : undefined}
                      >
                        <iframe className="material-item-preview" src={material.content} loading="eager" title="matpreview"></iframe>
                        <a className="material-item-info" href={material.content} target="_blank" rel="noreferrer">
                          {renamingId === material._id ? (
                            <input
                              className="mat-rename-input"
                              autoFocus
                              defaultValue={material.name}
                              value={renameValue}
                              onChange={e => setRenameValue(e.target.value)}
                              onClick={e => e.preventDefault()}
                              onKeyDown={e => {
                                if (e.key === 'Enter') handleRenameMaterial(material, renameValue);
                                if (e.key === 'Escape') setRenamingId(null);
                              }}
                              onBlur={() => handleRenameMaterial(material, renameValue)}
                            />
                          ) : (
                            <div className="material-item-title"> {material.name} </div>
                          )}
                          <div className="material-item-details">
                            <div className="material-item-detail"> {material.materialtype} </div>
                            <div className="material-item-detail"> {material.teacherinfo[1]} </div>
                          </div>
                        </a>
                        {(user?.providerData[0].email === material.teacherinfo[2] || appUser?.isAdmin) && (
                          <div className="material-admin-actions">
                            {isPrivileged && (
                              <button className="icon-button" onClick={e => {
                                e.preventDefault();
                                setRenameValue(material.name);
                                setRenamingId(material._id);
                              }}>
                                <EditIcon />
                              </button>
                            )}
                            <button className="icon-button" onClick={() => {
                              var newVisibility = !material.visible;
                              editMaterial(subject, gradeint, material.materialtype, material.content, material.topic, material.name, newVisibility, material).then((r) => {
                                if (r === "success") {
                                  updateMaterialVisibility(material, newVisibility);
                                  console.log("material visibility changed: ", material.visible);
                                }
                              })
                            }}>
                              {material.visible && material.visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </button>
                            <button className="icon-button" onClick={() => { handleRemoveMaterial(material); }}>
                              <DeleteIcon />
                            </button>
                          </div>
                        )}
                      </div>
                      {showIndicatorAfter && <div className="mat-drop-indicator" />}
                    </React.Fragment>
                  );
                })}
              </div>
            );
          })()}
        </div>{/* end .materials-wrapper */}

        {/* Canvas + actions live outside .materials-wrapper to get full page width */}
        {(() => {
          const textMat = materials?.find(m => m.materialtype === "text" && m.topic === textMatTopic);
          if (textMat) {
            return (
              <div>
                <div className="textmat-actions">
                  {isPrivileged && (
                    <button className="generic-button hover-up" onClick={subjectpagetexteditor}><EditNoteIcon />{t("admin.editcontent")}</button>
                  )}
                  <GenericPdfDownloader rootElementId="download-as-pdf" downloadFileName={subject + gradeint + textMat.topic.replaceAll("/", "-")} />
                </div>
                <CanvasDisplay html={textMat.content} />
              </div>
            );
          }
          // No text material exists for this topic — show placeholder for teachers/admins
          if (isPrivileged) {
            return (
              <div>
                <div className="textmat-actions">
                  <button className="generic-button hover-up" onClick={subjectpagetexteditor}><EditNoteIcon />{t("admin.editcontent")}</button>
                </div>
                <CanvasDisplay html={"<h1 style='opacity:0.35'>" + t("subjectpage.placeholder-textmat") + "</h1>"} />
              </div>
            );
          }
          return null;
        })()}
        <div className="materials-wrapper" style={{ padding: 0, border: 'none', background: 'none' }}>
          <br />

          {((materials && materials.length === 0) || (!materials)) && (
            console.log("materials.length: ", materials && materials.length),
            <div className="no-mats-text"><b>{t("subjectpage.no-materials-header")}</b>
              <br />{t("subjectpage.no-materials-text")}</div>
          )}

          {(appUser?.isAdmin || appUser?.accesslevel === "teacher") && (
            console.log("gradeint in subjectpage ", gradeint),
            <div className="add-material-popup">
              <div className="add-material-popup-wrapper">
                <div className="add-material-popup-header">
                  <h2>🖊️ <b>{t("admin.add-material")}</b></h2>
                  <button className="generic-button hover-up" onClick={closesubjectpageaddmaterial}> <CloseIcon /></button>
                </div>
                <div className="add-material-popup-body">
                  <div>
                    <MaterialAdd user={user} subjectfromurl={subject} gradefromurl={gradeint} actualGradefromurl={grade} defaultTopicFromTextMatTopic={textMatTopic} isOpenByDefault />
                  </div>
                </div>
              </div>
            </div>
          )}

          {(appUser?.isAdmin || appUser?.accesslevel === "teacher") && (
            <div className="admin-popup">
              <div className="admin-popup-wrapper">
                <div className="admin-popup-header">
                  <h2>🖊️ <b>{t("subjectpage.editpage")}</b></h2>
                  <button className="generic-button hover-up" onClick={closesubjectpageadmin}> <CloseIcon /></button>
                </div>
                <Admin user={user} subjectfromurl={subject} gradefromurl={gradeint} actualgradefromurlforsubject={grade} defaultTopicFromTextMatTopic={textMatTopic} />
                {/* <TextEditor user={user} subjectfromurl={subject} gradefromurl={gradeint} /> */}
              </div>
            </div>
          )}

          {(appUser?.isAdmin || appUser?.accesslevel === "teacher") && (
            <div className="texteditor-popup">
              <div className="texteditor-popup-wrapper">
                <div className="texteditor-popup-header">
                  <h2>🖊️ <b>{t("subjectpage.editpage")}</b> </h2>
                  <button className="generic-button hover-up" onClick={closesubjectpagetexteditor}> <CloseIcon /></button>
                </div>
                <div className="texteditor-popup-body">
                  <div>
                    <TextEditor user={user} subjectfromurl={subject} gradefromurl={gradeint} textMatTopic={textMatTopic} textMatTopicUnit={textMatTopicUnit} textMatTopicSubtopic1={textMatTopicSubtopic1} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {(appUser?.isAdmin || appUser?.accesslevel === "teacher") && (
            <div className="topics-popup">
              <div className="topics-popup-wrapper">
                <div className="topics-popup-header">
                  <h2>🖊️ <b>Sayfayı Düzenle</b> / Modifier la page </h2>
                  <button className="generic-button hover-up" onClick={closesubjectpagetopics}> <CloseIcon /></button>
                </div>
                <div className="topics-popup-body">
                  <div>
                    <TopicsPage user={user} subjectfromurl={subject} gradefromurl={gradeint} />
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
        <div className="footer">
          <p>©2024 <Link to="/team">Metaclass</Link></p>
          <span className="footer-links">
            {/* {(appUser?.accesslevel === "teacher") && (
              <>
                <a href="/myclasses" rel="noreferrer">{t("footer.myclasses")}</a>
                <span className="link-dot">•</span>
              </>
            )} */}

            {(appUser?.isAdmin) && ( // || appUser?.accesslevel === "teacher" removed from conditions: teachers should use their subject's page to edit.
              <>
                <Link to="/admin">{t("footer.admin")}</Link>
                <span className="link-dot">•</span>
              </>
            )}
            <a href="https://forms.gle/1dXApjbXShd4mSZD8" target="_blank" rel="noreferrer">{t("footer.feedback")}</a>
            <span className="link-dot">•</span> <LanguageSelector />

          </span>
        </div>

      </div>
    );
  } else return <AuthProvider><AuthPage user={user} /></AuthProvider>
}

export default SubjectPage;
